package one.healthium.profile.ui.update_food

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import loco.GENERAL_SAVE
import loco.UPDATE_FOOD_SCREEN_TITLE
import one.healthium.profile.ui.food.components.AmountPicker
import one.healthium.profile.ui.food.components.FoodDetails
import one.healthium.profile.ui.food.models.AmountUiModel
import one.healthium.profile.ui.food.models.FoodUiOptions
import one.healthium.profile.ui.food_history.models.FoodItemUiModel
import one.healthium.ui.common.event_producer.EventEffect
import one.healthium.ui.common.message.AlertUiMessageHandler
import one.healthium.ui.compose.components.AppProgressButton
import one.healthium.ui.compose.components.AppSheetTopBar
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

interface UpdateFoodEventDelegate {
    fun onCloseClicked()
    fun onFoodSaved()
}

@Composable
fun UpdateFoodScreen(
    foodItem: FoodItemUiModel,
    eventDelegate: UpdateFoodEventDelegate,
) {
    val viewModel = koinViewModel<UpdateFoodViewModel>()
    val state by viewModel.state.collectAsState()

    LaunchedEffect(foodItem) {
        viewModel.onFoodChanged(foodItem)
    }

    EventEffect(viewModel.events) { event ->
        when (event) {
            UpdateFoodEvents.OnFoodSaved -> eventDelegate.onFoodSaved()
        }
    }

    UpdateFoodScreenContent(
        state = state,
        onCloseClicked = eventDelegate::onCloseClicked,
        onSaveClicked = viewModel::onSaveClicked,
        onAmountChanged = viewModel::onAmountChanged,
    )

    AlertUiMessageHandler(viewModel.uiMessage)
}

@Composable
private fun UpdateFoodScreenContent(
    state: UpdateFoodUiState,
    onCloseClicked: () -> Unit,
    onSaveClicked: (FoodUiOptions) -> Unit,
    onAmountChanged: (AmountUiModel) -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .navigationBarsPadding(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        AppSheetTopBar(
            title = { Text(stringResource(loco.Res.string.UPDATE_FOOD_SCREEN_TITLE)) },
            onCloseClicked = onCloseClicked,
        )
        Spacer(Modifier.height(20.dp))
        if (state.options != null) {
            FoodDetails(state.options)
        }
        Spacer(Modifier.weight(1f))
        AppProgressButton(
            modifier = Modifier.defaultMinSize(minWidth = 176.dp),
            enabled = state.options != null,
            loading = state.loading,
            text = stringResource(loco.Res.string.GENERAL_SAVE),
            onClick = {
                state.options?.let(onSaveClicked)
            },
        )
        Spacer(Modifier.height(24.dp))
        if (state.amount != null) {
            AmountPicker(
                value = state.amount,
                onValueChanged = onAmountChanged,
            )
        }
        Spacer(Modifier.height(24.dp))
    }
}
